import { QuestControlProps } from './index'
import classNames from 'classnames'

interface Props extends QuestControlProps<boolean> {
  disabled?: boolean
}

const QuestBoolControl = ({ value, disabled, onChange }: Props) => {
  return (
    <div className={classNames('quest-bool-control', { disabled })}>
      <button
        type={'button'}
        disabled={disabled}
        className={classNames({ active: value === true })}
        onClick={() => onChange?.(true)}
      >
        Да
      </button>
      <button
        type={'button'}
        disabled={disabled}
        className={classNames({ active: value === false })}
        onClick={() => onChange?.(false)}
      >
        Нет
      </button>
    </div>
  )
}

export { QuestBoolControl }
